var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 10L3.11111 21H17.8889L20 10","stroke":"#0A1427","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M16 6.5C16 3.46243 13.5376 1 10.5 1C7.46243 1 5 3.46243 5 6.5","stroke":"#0A1427","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

Cart.defaultProps = {"width":"21","height":"22","viewBox":"0 0 21 22","fill":"none"};

module.exports = Cart;

Cart.default = Cart;
